'use client';

import { createClient } from '@/lib/supabase/client';

export type InquiryData = {
  companyName: string;
  contactName: string;
  email: string;
  phone: string;
  productInterest: string;
  orderVolume: string;
  message: string;
};

function isSchemaError(error: any): boolean {
  if (!error) return false;
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42') return true;
    if (errorClass === '23') return false;
    if (errorClass === '08') return true;
  }
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /syntax error/i,
    ];
    return schemaErrorPatterns.some((p) => p.test(error.message));
  }
  return false;
}

export const inquiryService = {
  async submit(data: InquiryData): Promise<{ success: boolean; error?: string }> {
    const supabase = createClient();
    try {
      const { error } = await supabase.from('inquiries').insert({
        company_name: data.companyName,
        contact_name: data.contactName,
        email: data.email,
        phone: data.phone,
        product_interest: data.productInterest,
        order_volume: data.orderVolume,
        message: data.message,
        inquiry_status: 'pending',
      });

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error submitting inquiry:', error.message);
          throw error;
        }
        console.log('Data error submitting inquiry:', error.message);
        return { success: false, error: error.message };
      }
      return { success: true };
    } catch (error: any) {
      console.log('Inquiry submit error:', error.message);
      return { success: false, error: error.message };
    }
  },
};
